import React, { useRef, useEffect } from 'react'
import styles from '../index.less'
import Image from '@/base-components/image'

import { ItemType } from '../interface.d'
import { ITEM_TRANSITION_TIMING } from '../config'
import { useWithReactFunctionalTrack } from '@du/analytics-sdk'
import { isInApp } from '@/utils'
import appInstall from '@/utils/appUtils/appInstall'
import Jockeys from '@/utils/jockey'
// import { getCouponDetail } from '@/components/poizon-new-user-coupon-v3/api'
// import { createTrackConfig } from '../trackConfig'
// import OutAppLink from '@/client/commonCom/link/OutAppLink'

const transitionTime = Math.floor(ITEM_TRANSITION_TIMING / 2)
const imgStyle = {
  transition: `width ${transitionTime}ms ease-in-out, height ${transitionTime}ms ease-in-out`,
}

const option = [{ mode: 'resize', width: 200 }]

type Props = ItemType & {
  needScene: boolean
  index: number
  CName: string
  pageId: string
  uid: string
  // outputBusiness: BusinessType
}
const ProductItem = (props: Props) => {
  const { redirect = {}, img, needScene } = props

  // const functionalPropsRef = useRef<any>({ ...props })
  const functionalRef = useRef(null)

  // useWithReactFunctionalTrack({
  //   functionalRef,
  //   functionalProps: functionalPropsRef.current,
  //   useEffect,
  //   // createTrackConfig,
  // })

  const { redirectKey, redirectValue } = redirect as any

  const goToDetail = (redirect) => {
    const { redirectKey, redirectValue } = redirect
    if (redirectKey === 0) return
    if (redirectKey === 1) {
      if (isInApp) {
        Jockeys.openNativePage(redirectValue)
      } else {
        appInstall(redirectValue)
      }
    }
    if (redirectKey === 2) {
      if (isInApp) {
        Jockeys.openNativePage('/web/browser', {
          url: encodeURIComponent(redirectValue),
        })
      } else {
        if (needScene) {
          window.location.href = redirectValue
        } else {
          appInstall(redirectValue)
        }
      }
    }
  }

  return (
    <div
      className={styles.imgBox}
      // data-track-click="venue_component_content_click"
      // data-track-exposure="venue_component_content_exposure"
      ref={functionalRef}
      onClick={() => goToDetail(redirect)}
    >
      {/* 这里的搭建器事配套的，没办法，只能用自己的Link理解 */}
      {/* todo: 这里需要补充跳转逻辑 */}
      <Image
        className={styles.img}
        src={img}
        style={imgStyle}
        data-key={redirectKey}
        data-url={redirectValue}
        options={option}
      />
    </div>
  )
}

export default ProductItem
